
import React from 'react';
import Loadable from 'react-loadable';
import { HashRouter, Route, Switch } from 'react-router-dom';
import './App.css';
import IsAuthenticated from './common/IsAuthenticated';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer } from 'react-notifications';

const loading = () => <div class="theme-loader" id="loader" ></div>
const DefaultLayout = Loadable({
  loader: () => import('./layout/Content'),
  loading
});

const Login = Loadable({
  loader: () => import('./common/Login'),
  loading
});


function App() {

  if (!IsAuthenticated()) {
    return (
      <HashRouter>
        <NotificationContainer />
        <Switch>
          <Route path="/" name="Login" component={Login} />
        </Switch>
      </HashRouter>
    )
  } else {
    return (

      <HashRouter>
        <NotificationContainer />
        <Switch>
          <Route path="/" name="Dashboard" component={DefaultLayout} />
        </Switch>
      </HashRouter>
    )
  }

}

export default App;

